var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _path8, _g5, _path9, _path0, _g6, _path1, _path10, _g7, _path11, _g8, _path12, _g9, _g0, _path13, _path14, _g1, _path15, _path16, _g10, _path17, _g11, _path18, _g12, _g13, _path19, _path20, _g14, _path21, _path22, _g15, _path23, _g16, _path24, _g17, _path25, _g18, _path26, _path27, _g19, _path28, _path29, _g20, _path30, _g21, _path31, _g22, _path32, _g23, _g24, _path33, _g25, _g26, _path34, _g27, _path35, _path36, _g28, _path37, _path38, _g29, _path39, _g30, _path40, _path41, _g31, _path42, _path43, _g32, _path44, _g33, _path45, _path46, _g34, _path47, _g35, _path48, _g36, _g37, _path49, _path50, _g38, _path51, _g39, _path52, _g40, _g41, _path53, _path54, _g42, _path55, _g43, _path56, _path57, _g44, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _g45, _path85, _g46, _path86, _g47, _path87, _path88, _g48, _path89, _g49, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiraffeAfraid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_181600)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.529 315C212.288 315 255.058 309.213 255.058 302.074C255.058 294.935 212.288 289.147 159.529 289.147C106.77 289.147 64 294.935 64 302.074C64 309.213 106.77 315 159.529 315Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.506 202.331C117.506 202.331 125.375 185.969 133.127 169.375C126.482 166.347 123.918 165.299 114.534 162.038C105.5 177.643 97.0482 193.772 97.7476 199.827L117.506 202.331Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 162,
    width: 37,
    height: 41
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.506 202.331C117.506 202.331 125.375 185.969 133.127 169.375C126.482 166.347 123.918 165.299 114.534 162.038C105.5 177.643 97.0482 193.772 97.7476 199.827L117.506 202.331Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.66 207.921C113.66 207.921 141.287 153.246 154.109 139.563L143.443 132.343C129.28 147.365 103.984 202.623 103.984 202.623L113.66 207.921Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 162,
    width: 37,
    height: 41
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.506 202.331C117.506 202.331 125.375 185.969 133.127 169.375C126.482 166.347 123.918 165.299 114.534 162.038C105.5 177.643 97.0482 193.772 97.7476 199.827L117.506 202.331Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.492 186.668C108.124 188.881 111.272 189.346 113.486 187.716C115.701 186.086 116.168 182.941 114.536 180.729C112.904 178.516 109.756 178.05 107.541 179.681C105.268 181.311 104.802 184.455 106.492 186.668Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 162,
    width: 37,
    height: 41
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.506 202.331C117.506 202.331 125.375 185.969 133.127 169.375C126.482 166.347 123.918 165.299 114.534 162.038C105.5 177.643 97.0482 193.772 97.7476 199.827L117.506 202.331Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.995 201.341C104.336 203.146 106.784 203.554 108.474 202.331C110.164 201.108 110.456 198.604 109.115 196.857C107.775 195.052 105.327 194.645 103.636 195.868C101.946 197.149 101.655 199.594 102.995 201.341Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 162,
    width: 37,
    height: 41
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.506 202.331C117.506 202.331 125.375 185.969 133.127 169.375C126.482 166.347 123.918 165.299 114.534 162.038C105.5 177.643 97.0482 193.772 97.7476 199.827L117.506 202.331Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.112 182.068C123.103 183.407 124.968 183.698 126.25 182.708C127.591 181.718 127.824 179.855 126.891 178.574C125.959 177.293 124.035 176.944 122.753 177.934C121.412 178.865 121.121 180.728 122.112 182.068Z",
    fill: "#673620"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.186 251.183C216.883 251.998 209.539 249.902 202.778 244.836C197.648 240.935 192.869 235.287 189.547 227.718L182.902 231.037C187.099 239.771 192.927 246.117 199.106 250.426C207.615 256.307 216.708 258.229 223.119 257.006L222.186 251.183Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 227,
    width: 42,
    height: 31
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222.186 251.183C216.883 251.998 209.539 249.902 202.778 244.836C197.648 240.935 192.869 235.287 189.547 227.718L182.902 231.037C187.099 239.771 192.927 246.117 199.106 250.426C207.615 256.307 216.708 258.229 223.119 257.006L222.186 251.183Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.284 234.938C187.858 237.616 190.422 240.061 192.579 242.216C198.582 248.155 205.518 252.464 213.503 254.444C215.66 254.968 217.874 255.608 220.148 255.666C220.322 255.666 220.789 256.249 220.905 256.365C221.605 256.947 222.304 257.413 223.062 257.821C225.277 259.043 227.666 259.626 230.173 259.509C235.535 259.335 239.965 256.249 243.462 252.173C244.627 250.833 245.735 249.436 246.842 247.98C247.25 247.398 247.716 246.758 248.124 246.175C248.183 246.117 248.474 245.651 248.591 245.768C248.824 246.059 248.299 247.049 248.183 247.34C247.542 249.028 246.784 250.601 245.91 252.173C242.296 258.578 236.584 263.41 229.298 264.051C226.034 264.342 222.712 263.818 219.74 262.479C218.166 261.78 216.767 260.557 215.193 259.917C212.396 258.869 209.365 258.752 206.567 257.646C197.766 254.094 189.431 247.282 184.594 238.78L186.284 234.938Z",
    fill: "#CE8710"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M222.478 260.384C217.99 259.335 213.036 252.931 218.747 248.913C226.266 243.556 233.61 247.748 237.166 245.186C236.816 247.108 234.718 249.32 229.996 250.951C229.53 251.125 231.92 250.893 232.328 250.834C234.776 250.427 236.758 249.029 238.448 247.341C242.295 243.556 243.868 244.196 243.81 244.255C240.488 248.447 239.147 252.639 237.807 254.212C232.561 260.442 227.723 261.665 222.478 260.384Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 216,
    y: 244,
    width: 28,
    height: 17
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M222.478 260.384C217.99 259.335 213.036 252.931 218.747 248.913C226.266 243.556 233.61 247.748 237.166 245.186C236.816 247.108 234.718 249.32 229.996 250.951C229.53 251.125 231.92 250.893 232.328 250.834C234.776 250.427 236.758 249.029 238.448 247.341C242.295 243.556 243.868 244.196 243.81 244.255C240.488 248.447 239.147 252.639 237.807 254.212C232.561 260.442 227.723 261.665 222.478 260.384Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.81 235.171C193.801 237.384 195.608 239.538 197.124 241.401C201.32 246.583 206.507 250.543 212.744 252.93C214.434 253.571 216.183 254.269 217.931 254.502C218.048 254.502 218.398 255.026 218.456 255.085C218.922 255.609 219.505 256.016 220.03 256.424C221.662 257.588 223.585 258.287 225.567 258.462C229.88 258.869 233.785 256.948 236.99 254.153C238.04 253.221 239.089 252.29 240.08 251.3C240.488 250.892 240.896 250.426 241.304 250.019C241.362 249.961 241.653 249.669 241.712 249.728C241.828 249.961 241.304 250.717 241.245 250.892C240.604 252.115 239.788 253.279 238.914 254.386C235.417 258.927 230.288 262.072 224.401 261.839C221.778 261.722 219.155 261.024 216.882 259.684C215.658 258.986 214.726 257.879 213.443 257.239C211.287 256.133 208.897 255.783 206.741 254.619C200.038 251.009 193.976 244.953 190.945 237.849L192.81 235.171Z",
    fill: "#301007"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M148.688 301.957C148.688 301.957 148.047 265.624 154.458 247.108L116.165 233.948C108.238 257.064 108.18 302.307 108.18 302.307L148.688 301.957Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 233,
    width: 47,
    height: 70
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.688 301.957C148.688 301.957 148.047 265.624 154.458 247.108L116.165 233.948C108.238 257.064 108.18 302.307 108.18 302.307L148.688 301.957Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.017 302.248C113.25 290.254 114.474 257.064 120.944 238.373L153.642 249.611C153.875 248.738 154.167 247.923 154.458 247.108L116.165 233.948C108.238 257.064 108.18 302.307 108.18 302.307L113.017 302.248Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 233,
    width: 47,
    height: 70
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.688 301.957C148.688 301.957 148.047 265.624 154.458 247.108L116.165 233.948C108.238 257.064 108.18 302.307 108.18 302.307L148.688 301.957Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.241 277.036C131.609 276.804 130.093 277.91 129.86 279.54C129.627 281.171 130.734 282.684 132.366 282.917C133.998 283.15 135.514 282.044 135.747 280.414C136.038 278.783 134.873 277.269 133.241 277.036ZM119.136 260.966C115.347 260.966 112.316 263.994 112.316 267.778C112.316 271.563 115.406 274.591 119.136 274.591C122.924 274.591 125.955 271.563 125.955 267.778C125.955 263.994 122.924 260.966 119.136 260.966Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 260,
    width: 24,
    height: 23
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 260,
    width: 24,
    height: 23
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.241 277.036C131.609 276.804 130.093 277.91 129.86 279.54C129.627 281.171 130.734 282.684 132.366 282.917C133.998 283.15 135.514 282.044 135.747 280.414C136.038 278.783 134.873 277.269 133.241 277.036ZM119.136 260.966C115.347 260.966 112.316 263.994 112.316 267.778C112.316 271.563 115.406 274.591 119.136 274.591C122.924 274.591 125.955 271.563 125.955 267.778C125.955 263.994 122.924 260.966 119.136 260.966Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.688 301.957C148.688 301.957 148.047 265.624 154.458 247.108L116.165 233.948C108.238 257.064 108.18 302.307 108.18 302.307L148.688 301.957Z",
    fill: "white"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.017 302.248C113.25 290.254 114.474 257.064 120.944 238.373L153.642 249.611C153.875 248.738 154.167 247.923 154.458 247.108L116.165 233.948C108.238 257.064 108.18 302.307 108.18 302.307L113.017 302.248Z",
    fill: "#C3A088"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.765 303.064C108.007 303.064 107.308 302.656 106.9 302.016C106.492 301.375 106.492 300.56 106.841 299.861C110.455 293.515 120.13 288.856 129.981 288.856C140.122 288.856 147.408 293.747 150.089 300.385C150.322 300.968 150.264 301.666 149.914 302.19C149.564 302.714 148.981 303.006 148.34 303.006C140.53 303.064 117.216 303.064 108.765 303.064Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 288,
    width: 45,
    height: 16
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.765 303.064C108.007 303.064 107.308 302.656 106.9 302.016C106.492 301.375 106.492 300.56 106.841 299.861C110.455 293.515 120.13 288.856 129.981 288.856C140.122 288.856 147.408 293.747 150.089 300.385C150.322 300.968 150.264 301.666 149.914 302.19C149.564 302.714 148.981 303.006 148.34 303.006C140.53 303.064 117.216 303.064 108.765 303.064Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.267 297.882C105.792 298.697 106.724 299.221 107.773 299.221C117.682 299.221 140.821 299.221 149.855 299.163C150.671 299.163 151.429 298.813 151.895 298.173C152.186 298.581 152.42 298.988 152.653 299.396C153.061 300.153 153.061 301.084 152.594 301.841C152.128 302.598 151.312 303.064 150.38 303.064C141.112 303.122 117.215 303.122 107.074 303.122C105.966 303.122 104.917 302.482 104.451 301.55C103.926 300.56 104.043 299.454 104.742 298.581C104.917 298.289 105.092 298.115 105.267 297.882Z",
    fill: "#301007"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M170.313 301.957C170.313 301.957 170.954 265.624 164.543 247.108L202.836 233.948C210.763 257.064 210.821 302.307 210.821 302.307L170.313 301.957Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 233,
    width: 47,
    height: 70
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.313 301.957C170.313 301.957 170.954 265.624 164.543 247.108L202.836 233.948C210.763 257.064 210.821 302.307 210.821 302.307L170.313 301.957Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.984 302.248C205.75 290.254 204.526 257.064 198.057 238.373L165.359 249.611C165.126 248.738 164.834 247.923 164.543 247.108L202.836 233.948C210.763 257.064 210.821 302.307 210.821 302.307L205.984 302.248Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 233,
    width: 47,
    height: 70
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M170.313 301.957C170.313 301.957 170.954 265.624 164.543 247.108L202.836 233.948C210.763 257.064 210.821 302.307 210.821 302.307L170.313 301.957Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.475 277.036C186.107 276.804 187.622 277.91 187.855 279.54C188.088 281.171 186.981 282.684 185.349 282.917C183.717 283.15 182.202 282.044 181.968 280.414C181.735 278.783 182.843 277.269 184.475 277.036ZM198.58 260.966C202.368 260.966 205.399 263.994 205.399 267.778C205.399 271.563 202.368 274.591 198.58 274.591C194.791 274.591 191.76 271.563 191.76 267.778C191.76 263.994 194.791 260.966 198.58 260.966Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 260,
    width: 25,
    height: 23
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 260,
    width: 25,
    height: 23
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.475 277.036C186.107 276.804 187.622 277.91 187.855 279.54C188.088 281.171 186.981 282.684 185.349 282.917C183.717 283.15 182.202 282.044 181.968 280.414C181.735 278.783 182.843 277.269 184.475 277.036ZM198.58 260.966C202.368 260.966 205.399 263.994 205.399 267.778C205.399 271.563 202.368 274.591 198.58 274.591C194.791 274.591 191.76 271.563 191.76 267.778C191.76 263.994 194.791 260.966 198.58 260.966Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.313 301.957C170.313 301.957 170.954 265.624 164.543 247.108L202.836 233.948C210.763 257.064 210.821 302.307 210.821 302.307L170.313 301.957Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.984 302.248C205.75 290.254 204.526 257.064 198.057 238.373L165.359 249.611C165.126 248.738 164.834 247.923 164.543 247.108L202.836 233.948C210.763 257.064 210.821 302.307 210.821 302.307L205.984 302.248Z",
    fill: "#301007"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M210.237 303.064C210.995 303.064 211.695 302.656 212.103 302.016C212.511 301.375 212.511 300.56 212.161 299.861C208.547 293.515 198.872 288.856 189.022 288.856C178.88 288.856 171.594 293.747 168.913 300.385C168.68 300.968 168.738 301.666 169.088 302.19C169.438 302.714 170.021 303.006 170.662 303.006C178.53 303.064 201.786 303.064 210.237 303.064Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 288,
    width: 45,
    height: 16
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M210.237 303.064C210.995 303.064 211.695 302.656 212.103 302.016C212.511 301.375 212.511 300.56 212.161 299.861C208.547 293.515 198.872 288.856 189.022 288.856C178.88 288.856 171.594 293.747 168.913 300.385C168.68 300.968 168.738 301.666 169.088 302.19C169.438 302.714 170.021 303.006 170.662 303.006C178.53 303.064 201.786 303.064 210.237 303.064Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.736 297.882C213.211 298.697 212.278 299.221 211.229 299.221C201.321 299.221 178.182 299.221 169.148 299.163C168.332 299.163 167.574 298.813 167.108 298.173C166.816 298.581 166.583 298.988 166.35 299.396C165.942 300.153 165.942 301.084 166.408 301.841C166.874 302.598 167.69 303.064 168.623 303.064C177.89 303.122 201.787 303.122 211.929 303.122C213.036 303.122 214.085 302.482 214.552 301.55C215.076 300.56 214.901 299.454 214.26 298.581C214.144 298.289 213.91 298.115 213.736 297.882Z",
    fill: "#301007"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M217.116 219.333C217.116 219.333 189.839 181.311 174.918 171.238L186.05 155.633C202.487 166.754 233.028 208.386 233.028 208.386L217.116 219.333Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 155,
    width: 60,
    height: 65
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M217.116 219.333C217.116 219.333 189.839 181.311 174.918 171.238L186.05 155.633C202.487 166.754 233.028 208.386 233.028 208.386L217.116 219.333Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.561 224.807C213.561 224.807 176.492 179.856 161.629 169.84L170.255 161.106C186.691 172.228 221.662 218.111 221.662 218.111L213.561 224.807Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 155,
    width: 60,
    height: 65
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M217.116 219.333C217.116 219.333 189.839 181.311 174.918 171.238L186.05 155.633C202.487 166.754 233.028 208.386 233.028 208.386L217.116 219.333Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.875 191.966C215.485 193.305 212.396 192.49 211.055 190.044C209.715 187.657 210.589 184.571 212.979 183.232C215.368 181.893 218.457 182.708 219.798 185.153C221.139 187.599 220.264 190.627 217.875 191.966Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 155,
    width: 60,
    height: 65
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M217.116 219.333C217.116 219.333 189.839 181.311 174.918 171.238L186.05 155.633C202.487 166.754 233.028 208.386 233.028 208.386L217.116 219.333Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.02 206.814C213.096 207.921 210.648 207.28 209.658 205.475C208.608 203.67 209.366 201.283 211.289 200.176C213.213 199.07 215.661 199.711 216.652 201.516C217.701 203.379 216.943 205.708 215.02 206.814Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 155,
    width: 60,
    height: 65
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M217.116 219.333C217.116 219.333 189.839 181.311 174.918 171.238L186.05 155.633C202.487 166.754 233.028 208.386 233.028 208.386L217.116 219.333Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.52 181.427C204.062 182.243 202.256 181.719 201.44 180.321C200.624 178.924 201.148 177.06 202.605 176.303C204.062 175.488 205.869 176.012 206.685 177.41C207.443 178.807 206.918 180.612 205.52 181.427Z",
    fill: "#673620"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M232.792 208.153C247.013 215.839 246.722 235.462 233.491 234.821C228.887 234.588 223.466 228.649 221.776 224.282C221.834 226.029 221.076 230.396 218.395 228.94C217.346 228.358 216.122 224.049 216.938 218.984C220.435 213.685 227.721 208.153 232.792 208.153Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 216,
    y: 208,
    width: 28,
    height: 27
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M232.792 208.153C247.013 215.839 246.722 235.462 233.491 234.821C228.887 234.588 223.466 228.649 221.776 224.282C221.834 226.029 221.076 230.396 218.395 228.94C217.346 228.358 216.122 224.049 216.938 218.984C220.435 213.685 227.721 208.153 232.792 208.153Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.922 214.442C218.805 214.326 222.827 218.227 224.051 221.429C228.83 232.958 240.079 237.383 244.858 224.806C244.276 235.578 233.143 239.654 226.848 238.373C220.262 236.976 215.308 231.27 213.443 224.865C212.685 222.303 212.335 219.391 213.21 216.771L218.922 214.442Z",
    fill: "#301007"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M191.876 156.623H127.121C119.661 181.777 113.891 206.756 113.891 223.759C113.891 253.687 134.232 269.292 159.411 269.292C184.59 269.292 205.107 253.746 205.107 223.759C205.107 206.815 199.336 181.835 191.876 156.623Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 156,
    width: 93,
    height: 114
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M191.876 156.623H127.121C119.661 181.777 113.891 206.756 113.891 223.759C113.891 253.687 134.232 269.292 159.411 269.292C184.59 269.292 205.107 253.746 205.107 223.759C205.107 206.815 199.336 181.835 191.876 156.623Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.717 156.623H127.121C119.661 181.777 113.891 206.756 113.891 223.759C113.891 237.034 117.912 249.204 124.615 258.637C120.827 250.135 118.67 240.353 118.67 229.931C118.67 213.045 124.149 182.883 132.717 156.623Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 156,
    width: 93,
    height: 114
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M191.876 156.623H127.121C119.661 181.777 113.891 206.756 113.891 223.759C113.891 253.687 134.232 269.292 159.411 269.292C184.59 269.292 205.107 253.746 205.107 223.759C205.107 206.815 199.336 181.835 191.876 156.623Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.281 156.623H191.877C199.337 181.777 205.107 206.756 205.107 223.759C205.107 237.034 201.086 249.204 194.383 258.637C198.171 250.135 200.328 240.353 200.328 229.931C200.328 213.045 194.849 182.883 186.281 156.623Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 156,
    width: 93,
    height: 114
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M191.876 156.623H127.121C119.661 181.777 113.891 206.756 113.891 223.759C113.891 253.687 134.232 269.292 159.411 269.292C184.59 269.292 205.107 253.746 205.107 223.759C205.107 206.815 199.336 181.835 191.876 156.623Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.25 237.442C129.686 237.442 127.587 239.597 127.587 242.275C127.587 244.954 129.686 247.108 132.25 247.108C134.815 247.108 136.913 244.954 136.913 242.275C136.913 239.597 134.815 237.442 132.25 237.442ZM187.738 237.733C190.244 237.733 192.226 239.597 192.226 241.926C192.226 244.255 190.186 246.118 187.738 246.118C185.231 246.118 183.25 244.255 183.25 241.926C183.191 239.655 185.231 237.733 187.738 237.733ZM199.453 220.906C202.251 220.906 204.465 223.119 204.465 225.913C204.465 228.65 202.192 230.921 199.453 230.921C196.655 230.921 194.44 228.708 194.44 225.913C194.382 223.119 196.655 220.906 199.453 220.906ZM118.145 219.45C115.348 219.45 113.133 221.663 113.133 224.458C113.133 227.194 115.406 229.465 118.145 229.465C120.943 229.465 123.158 227.253 123.158 224.458C123.158 221.663 120.885 219.45 118.145 219.45ZM189.136 210.483C190.768 210.483 192.109 211.822 192.109 213.453C192.109 215.083 190.768 216.422 189.136 216.422C187.504 216.422 186.164 215.083 186.164 213.453C186.164 211.822 187.446 210.483 189.136 210.483ZM128.753 208.096C127.121 208.096 125.781 209.435 125.781 211.066C125.781 212.696 127.121 214.035 128.753 214.035C130.385 214.035 131.726 212.696 131.726 211.066C131.726 209.377 130.385 208.096 128.753 208.096ZM197.938 186.96C201.726 186.96 204.757 189.987 204.757 193.772C204.757 197.499 201.726 200.585 197.938 200.585C194.149 200.585 191.118 197.557 191.118 193.772C191.118 189.987 194.149 186.96 197.938 186.96ZM120.652 186.96C116.863 186.96 113.832 189.987 113.832 193.772C113.832 197.499 116.863 200.585 120.652 200.585C124.44 200.585 127.471 197.557 127.471 193.772C127.471 189.987 124.44 186.96 120.652 186.96ZM185.581 177.76C187.213 177.76 188.554 179.099 188.554 180.729C188.554 182.36 187.213 183.699 185.581 183.699C183.949 183.699 182.609 182.36 182.609 180.729C182.609 179.099 183.949 177.76 185.581 177.76ZM133.008 177.76C131.376 177.76 130.035 179.099 130.035 180.729C130.035 182.36 131.376 183.699 133.008 183.699C134.64 183.699 135.981 182.36 135.981 180.729C135.981 179.099 134.64 177.76 133.008 177.76Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 177,
    width: 92,
    height: 71
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 177,
    width: 92,
    height: 71
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M132.25 237.441C129.686 237.441 127.587 239.596 127.587 242.274C127.587 244.953 129.686 247.107 132.25 247.107C134.815 247.107 136.913 244.953 136.913 242.274C136.913 239.596 134.815 237.441 132.25 237.441ZM187.738 237.732C190.244 237.732 192.226 239.596 192.226 241.925C192.226 244.254 190.186 246.117 187.738 246.117C185.231 246.117 183.25 244.254 183.25 241.925C183.191 239.654 185.231 237.732 187.738 237.732ZM199.453 220.905C202.251 220.905 204.465 223.118 204.465 225.912C204.465 228.649 202.192 230.92 199.453 230.92C196.655 230.92 194.44 228.707 194.44 225.912C194.382 223.118 196.655 220.905 199.453 220.905ZM118.145 219.449C115.348 219.449 113.133 221.662 113.133 224.457C113.133 227.193 115.406 229.464 118.145 229.464C120.943 229.464 123.158 227.252 123.158 224.457C123.158 221.662 120.885 219.449 118.145 219.449ZM189.136 210.482C190.768 210.482 192.109 211.822 192.109 213.452C192.109 215.082 190.768 216.421 189.136 216.421C187.504 216.421 186.164 215.082 186.164 213.452C186.164 211.822 187.446 210.482 189.136 210.482ZM128.753 208.095C127.121 208.095 125.781 209.434 125.781 211.065C125.781 212.695 127.121 214.034 128.753 214.034C130.385 214.034 131.726 212.695 131.726 211.065C131.726 209.376 130.385 208.095 128.753 208.095ZM197.938 186.959C201.726 186.959 204.757 189.986 204.757 193.771C204.757 197.498 201.726 200.584 197.938 200.584C194.149 200.584 191.118 197.556 191.118 193.771C191.118 189.986 194.149 186.959 197.938 186.959ZM120.652 186.959C116.863 186.959 113.832 189.986 113.832 193.771C113.832 197.498 116.863 200.584 120.652 200.584C124.44 200.584 127.471 197.556 127.471 193.771C127.471 189.986 124.44 186.959 120.652 186.959ZM185.581 177.759C187.213 177.759 188.554 179.098 188.554 180.728C188.554 182.359 187.213 183.698 185.581 183.698C183.949 183.698 182.609 182.359 182.609 180.728C182.609 179.098 183.949 177.759 185.581 177.759ZM133.008 177.759C131.376 177.759 130.035 179.098 130.035 180.728C130.035 182.359 131.376 183.698 133.008 183.698C134.64 183.698 135.981 182.359 135.981 180.728C135.981 179.098 134.64 177.759 133.008 177.759Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.876 156.622H127.121C119.661 181.776 113.891 206.755 113.891 223.758C113.891 253.686 134.232 269.291 159.411 269.291C184.59 269.291 205.107 253.745 205.107 223.758C205.107 206.814 199.336 181.834 191.876 156.622Z",
    fill: "white"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.281 156.622H191.877C199.337 181.776 205.107 206.755 205.107 223.758C205.107 237.033 201.086 249.203 194.383 258.636C198.171 250.134 200.328 240.352 200.328 229.93C200.328 213.044 194.849 182.882 186.281 156.622Z",
    fill: "#301007"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 177,
    width: 92,
    height: 71
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 177,
    width: 92,
    height: 71
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M132.25 237.441C129.686 237.441 127.587 239.596 127.587 242.274C127.587 244.953 129.686 247.107 132.25 247.107C134.815 247.107 136.913 244.953 136.913 242.274C136.913 239.596 134.815 237.441 132.25 237.441ZM187.738 237.732C190.244 237.732 192.226 239.596 192.226 241.925C192.226 244.254 190.186 246.117 187.738 246.117C185.231 246.117 183.25 244.254 183.25 241.925C183.191 239.654 185.231 237.732 187.738 237.732ZM199.453 220.905C202.251 220.905 204.465 223.118 204.465 225.912C204.465 228.649 202.192 230.92 199.453 230.92C196.655 230.92 194.44 228.707 194.44 225.912C194.382 223.118 196.655 220.905 199.453 220.905ZM118.145 219.449C115.348 219.449 113.133 221.662 113.133 224.457C113.133 227.193 115.406 229.464 118.145 229.464C120.943 229.464 123.158 227.252 123.158 224.457C123.158 221.662 120.885 219.449 118.145 219.449ZM189.136 210.482C190.768 210.482 192.109 211.822 192.109 213.452C192.109 215.082 190.768 216.421 189.136 216.421C187.504 216.421 186.164 215.082 186.164 213.452C186.164 211.822 187.446 210.482 189.136 210.482ZM128.753 208.095C127.121 208.095 125.781 209.434 125.781 211.065C125.781 212.695 127.121 214.034 128.753 214.034C130.385 214.034 131.726 212.695 131.726 211.065C131.726 209.376 130.385 208.095 128.753 208.095ZM197.938 186.959C201.726 186.959 204.757 189.986 204.757 193.771C204.757 197.498 201.726 200.584 197.938 200.584C194.149 200.584 191.118 197.556 191.118 193.771C191.118 189.986 194.149 186.959 197.938 186.959ZM120.652 186.959C116.863 186.959 113.832 189.986 113.832 193.771C113.832 197.498 116.863 200.584 120.652 200.584C124.44 200.584 127.471 197.556 127.471 193.771C127.471 189.986 124.44 186.959 120.652 186.959ZM185.581 177.759C187.213 177.759 188.554 179.098 188.554 180.728C188.554 182.359 187.213 183.698 185.581 183.698C183.949 183.698 182.609 182.359 182.609 180.728C182.609 179.098 183.949 177.759 185.581 177.759ZM133.008 177.759C131.376 177.759 130.035 179.098 130.035 180.728C130.035 182.359 131.376 183.698 133.008 183.698C134.64 183.698 135.981 182.359 135.981 180.728C135.981 179.098 134.64 177.759 133.008 177.759Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.876 156.622H127.121C119.661 181.776 113.891 206.755 113.891 223.758C113.891 253.686 134.232 269.291 159.411 269.291C184.59 269.291 205.107 253.745 205.107 223.758C205.107 206.814 199.336 181.834 191.876 156.622Z",
    fill: "white"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.717 156.622H127.121C119.661 181.776 113.891 206.755 113.891 223.758C113.891 237.033 117.912 249.203 124.615 258.636C120.827 250.134 118.67 240.352 118.67 229.93C118.67 213.044 124.149 182.882 132.717 156.622Z",
    fill: "#9D6E51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 156,
    width: 93,
    height: 114
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M191.876 156.623H127.121C119.661 181.777 113.891 206.756 113.891 223.759C113.891 253.687 134.232 269.292 159.411 269.292C184.59 269.292 205.107 253.746 205.107 223.759C205.107 206.815 199.336 181.835 191.876 156.623Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.168 143.114C177.772 161.98 184.65 200.351 184.65 213.336C184.65 232.26 174.1 244.08 159.587 244.08C145.074 244.08 134.059 232.26 134.059 213.336C134.059 200.351 140.878 161.98 145.482 143.114H173.168Z",
    fill: "#EFD36F"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.762 15.7139L133.477 17.6354L139.888 41.916L147.174 39.9945L140.762 15.7139Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 15,
    width: 15,
    height: 27
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M140.762 15.7139L133.477 17.6354L139.888 41.916L147.174 39.9945L140.762 15.7139Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.59 18.3341L135.691 16.1797L142.161 40.5185L134.059 42.6147L127.59 18.3341Z",
    fill: "#CE8710"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M136.389 5C141.11 5 144.957 8.84297 144.957 13.5594C144.957 18.2757 141.11 22.1187 136.389 22.1187C131.668 22.1187 127.821 18.2757 127.821 13.5594C127.763 8.84297 131.609 5 136.389 5Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 5,
    width: 18,
    height: 18
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M136.389 5C141.11 5 144.957 8.84297 144.957 13.5594C144.957 18.2757 141.11 22.1187 136.389 22.1187C131.668 22.1187 127.821 18.2757 127.821 13.5594C127.763 8.84297 131.609 5 136.389 5Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.4 7.5037C135.75 7.91129 134.934 9.13405 133.651 10.2404C132.369 11.3467 131.029 11.9289 130.679 11.5796C130.329 11.172 131.145 9.94923 132.427 8.84292C133.71 7.67838 135.05 7.09611 135.4 7.5037Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 5,
    width: 18,
    height: 18
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M136.389 5C141.11 5 144.957 8.84297 144.957 13.5594C144.957 18.2757 141.11 22.1187 136.389 22.1187C131.668 22.1187 127.821 18.2757 127.821 13.5594C127.763 8.84297 131.609 5 136.389 5Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.734 9.13379C144.492 10.4148 144.958 11.9287 144.958 13.559C144.958 18.2754 141.111 22.1184 136.39 22.1184C132.543 22.1184 129.279 19.5564 128.172 16.121C129.687 18.6248 132.427 20.2551 135.516 20.2551C140.237 20.2551 144.084 16.4122 144.084 11.6958C144.084 10.7641 143.967 9.94897 143.734 9.13379Z",
    fill: "#301007"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M178.239 15.7139L185.525 17.6354L179.114 41.916L171.828 39.9945L178.239 15.7139Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 15,
    width: 15,
    height: 27
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M178.239 15.7139L185.525 17.6354L179.114 41.916L171.828 39.9945L178.239 15.7139Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.411 18.3341L183.31 16.1797L176.898 40.5185L185 42.6147L191.411 18.3341Z",
    fill: "#CE8710"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M182.669 5C177.948 5 174.102 8.84297 174.102 13.5594C174.102 18.2757 177.948 22.1187 182.669 22.1187C187.391 22.1187 191.237 18.2757 191.237 13.5594C191.237 8.84297 187.391 5 182.669 5Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 5,
    width: 18,
    height: 18
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M182.669 5C177.948 5 174.102 8.84297 174.102 13.5594C174.102 18.2757 177.948 22.1187 182.669 22.1187C187.391 22.1187 191.237 18.2757 191.237 13.5594C191.237 8.84297 187.391 5 182.669 5Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.601 7.5037C183.251 7.91129 184.067 9.13405 185.349 10.2404C186.632 11.3467 187.972 11.9289 188.322 11.5796C188.672 11.172 187.856 9.94923 186.573 8.84292C185.291 7.67838 183.95 7.09611 183.601 7.5037Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 5,
    width: 18,
    height: 18
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M182.669 5C177.948 5 174.102 8.84297 174.102 13.5594C174.102 18.2757 177.948 22.1187 182.669 22.1187C187.391 22.1187 191.237 18.2757 191.237 13.5594C191.237 8.84297 187.391 5 182.669 5Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.267 9.13379C174.509 10.4148 174.043 11.9287 174.043 13.559C174.043 18.2754 177.89 22.1184 182.611 22.1184C186.458 22.1184 189.722 19.5564 190.829 16.121C189.314 18.6248 186.574 20.2551 183.485 20.2551C178.764 20.2551 174.917 16.4122 174.917 11.6958C174.917 10.7641 175.034 9.94897 175.267 9.13379Z",
    fill: "#301007"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M184.067 45.0605C184.009 45.5845 184.475 44.0706 184.709 43.6048C185.233 42.6149 185.874 41.6833 186.457 40.7517C188.206 38.1315 190.071 35.5113 192.053 33.0657C198.114 25.6709 205.924 19.9065 214.492 15.6559C216.882 14.4914 221.37 11.58 223.993 13.5597C227.548 16.2964 224.459 26.6025 223.352 29.9797C219.563 41.334 206.274 53.2122 193.043 53.4451L184.067 45.0605Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 12,
    width: 42,
    height: 42
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M184.067 45.0605C184.009 45.5845 184.475 44.0706 184.709 43.6048C185.233 42.6149 185.874 41.6833 186.457 40.7517C188.206 38.1315 190.071 35.5113 192.053 33.0657C198.114 25.6709 205.924 19.9065 214.492 15.6559C216.882 14.4914 221.37 11.58 223.993 13.5597C227.548 16.2964 224.459 26.6025 223.352 29.9797C219.563 41.334 206.274 53.2122 193.043 53.4451L184.067 45.0605Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.478 9.60031C222.536 9.19272 223.003 10.2408 223.236 10.6484C223.644 11.3471 223.877 12.1623 224.11 12.9192C224.693 15.2483 225.043 17.7521 224.635 20.0812C223.352 27.1848 219.039 33.2404 214.143 38.4226C212.511 40.1112 210.821 41.7998 209.014 43.3719C206.974 45.1187 204.876 46.8073 202.486 48.0301C202.02 48.263 200.68 49.1364 200.097 48.9617C199.281 48.7288 198.29 46.8655 197.707 46.2833C195.434 44.0124 192.578 42.3821 189.605 41.2175C189.023 40.9846 187.216 40.1112 186.575 40.4023C186.458 40.4606 188.731 42.7314 188.848 42.9061C190.305 44.4782 191.704 46.1086 192.986 47.8554C195.143 50.7085 197.066 53.7363 198.523 56.997C198.814 57.6375 199.514 60.5488 200.272 60.84C201.029 61.1311 203.186 59.4425 203.71 59.1514C207.324 56.997 210.705 54.6097 213.852 51.9313C222.303 44.7694 227.957 34.4632 229.414 23.5165C230.172 17.8685 229.356 11.3471 225.392 6.92188L222.478 9.60031Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 12,
    width: 42,
    height: 42
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M184.067 45.0605C184.009 45.5845 184.475 44.0706 184.709 43.6048C185.233 42.6149 185.874 41.6833 186.457 40.7517C188.206 38.1315 190.071 35.5113 192.053 33.0657C198.114 25.6709 205.924 19.9065 214.492 15.6559C216.882 14.4914 221.37 11.58 223.993 13.5597C227.548 16.2964 224.459 26.6025 223.352 29.9797C219.563 41.334 206.274 53.2122 193.043 53.4451L184.067 45.0605Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.992 51.5815C185.875 51.4651 187.216 49.6018 187.332 49.4854C188.906 47.2145 190.654 45.1183 192.461 43.0804C197.415 37.4324 203.244 31.9008 209.83 28.4655C210.704 27.9996 211.637 27.5338 212.628 27.1845C214.551 26.4275 217.757 25.9035 217.057 29.1642C216.941 29.6882 216.766 30.154 216.591 30.6781C215.192 34.1717 212.744 37.3159 210.18 39.9362C207.79 42.3817 204.934 44.3032 202.078 46.05C197.882 48.612 193.394 50.1259 188.906 52.0473L185.992 51.5815Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 26,
    width: 33,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 26,
    width: 33,
    height: 27
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M185.992 51.5815C185.875 51.4651 187.216 49.6018 187.332 49.4854C188.906 47.2145 190.654 45.1183 192.461 43.0804C197.415 37.4324 203.244 31.9008 209.83 28.4655C210.704 27.9996 211.637 27.5338 212.628 27.1845C214.551 26.4275 217.757 25.9035 217.057 29.1642C216.941 29.6882 216.766 30.154 216.591 30.6781C215.192 34.1717 212.744 37.3159 210.18 39.9362C207.79 42.3817 204.934 44.3032 202.078 46.05C197.882 48.612 193.394 50.1259 188.906 52.0473L185.992 51.5815Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.067 45.0605C184.009 45.5845 184.475 44.0706 184.709 43.6048C185.233 42.6149 185.874 41.6833 186.457 40.7517C188.206 38.1315 190.071 35.5113 192.053 33.0657C198.114 25.6709 205.924 19.9065 214.492 15.6559C216.882 14.4914 221.37 11.58 223.993 13.5597C227.548 16.2964 224.459 26.6025 223.352 29.9797C219.563 41.334 206.274 53.2122 193.043 53.4451L184.067 45.0605Z",
    fill: "white"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.478 9.60031C222.536 9.19272 223.003 10.2408 223.236 10.6484C223.644 11.3471 223.877 12.1623 224.11 12.9192C224.693 15.2483 225.043 17.7521 224.635 20.0812C223.352 27.1848 219.039 33.2404 214.143 38.4226C212.511 40.1112 210.821 41.7998 209.014 43.3719C206.974 45.1187 204.876 46.8073 202.486 48.0301C202.02 48.263 200.68 49.1364 200.097 48.9617C199.281 48.7288 198.29 46.8655 197.707 46.2833C195.434 44.0124 192.578 42.3821 189.605 41.2175C189.023 40.9846 187.216 40.1112 186.575 40.4023C186.458 40.4606 188.731 42.7314 188.848 42.9061C190.305 44.4782 191.704 46.1086 192.986 47.8554C195.143 50.7085 197.066 53.7363 198.523 56.997C198.814 57.6375 199.514 60.5488 200.272 60.84C201.029 61.1311 203.186 59.4425 203.71 59.1514C207.324 56.997 210.705 54.6097 213.852 51.9313C222.303 44.7694 227.957 34.4632 229.414 23.5165C230.172 17.8685 229.356 11.3471 225.392 6.92188L222.478 9.60031Z",
    fill: "#EEC18F"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M134.934 45.0599C134.992 45.5839 134.526 44.07 134.293 43.6042C133.768 42.6143 133.127 41.6827 132.544 40.7511C130.796 38.1309 128.931 35.5107 126.949 33.0651C120.887 25.7285 113.019 19.9058 104.451 15.7135C102.061 14.549 97.5734 11.6376 94.9505 13.6173C91.3951 16.354 94.4842 26.6602 95.5917 30.0373C99.3802 41.3916 112.669 53.2699 125.9 53.5028L134.934 45.0599Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 12,
    width: 42,
    height: 42
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M134.934 45.0599C134.992 45.5839 134.526 44.07 134.293 43.6042C133.768 42.6143 133.127 41.6827 132.544 40.7511C130.796 38.1309 128.931 35.5107 126.949 33.0651C120.887 25.7285 113.019 19.9058 104.451 15.7135C102.061 14.549 97.5734 11.6376 94.9505 13.6173C91.3951 16.354 94.4842 26.6602 95.5917 30.0373C99.3802 41.3916 112.669 53.2699 125.9 53.5028L134.934 45.0599Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5231 9.59921C96.4648 9.19162 95.9986 10.2397 95.7654 10.6473C95.3574 11.346 95.1243 12.1612 94.8912 12.9181C94.3083 15.2472 93.9586 17.751 94.3666 20.0801C95.6489 27.1837 99.9619 33.2393 104.858 38.4215C106.49 40.1101 108.18 41.7987 109.987 43.3708C112.027 45.1176 114.125 46.8062 116.515 48.029C116.981 48.2619 118.322 49.1353 118.905 48.9606C119.721 48.7277 120.711 46.8644 121.294 46.2822C123.567 44.0113 126.423 42.381 129.396 41.2164C129.979 40.9835 131.727 40.1101 132.427 40.4012C132.543 40.4595 130.27 42.7303 130.154 42.905C128.696 44.4771 127.298 46.1075 126.015 47.8543C123.859 50.7074 121.935 53.7352 120.478 56.9959C120.187 57.6364 119.487 60.5477 118.73 60.8389C117.972 61.13 115.815 59.4414 115.291 59.1503C111.677 56.9959 108.297 54.6086 105.149 51.9302C96.7563 44.5936 91.0443 34.3456 89.6455 23.3408C88.8878 17.6927 89.7038 11.1713 93.6672 6.74609L96.5231 9.59921Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 12,
    width: 42,
    height: 42
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M134.934 45.0599C134.992 45.5839 134.526 44.07 134.293 43.6042C133.768 42.6143 133.127 41.6827 132.544 40.7511C130.796 38.1309 128.931 35.5107 126.949 33.0651C120.887 25.7285 113.019 19.9058 104.451 15.7135C102.061 14.549 97.5734 11.6376 94.9505 13.6173C91.3951 16.354 94.4842 26.6602 95.5917 30.0373C99.3802 41.3916 112.669 53.2699 125.9 53.5028L134.934 45.0599Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.012 51.5815C133.128 51.4651 131.788 49.6018 131.671 49.4854C130.097 47.2145 128.349 45.1183 126.542 43.0804C121.588 37.4324 115.759 31.9008 109.173 28.4655C108.299 27.9996 107.366 27.5338 106.375 27.1845C104.452 26.4275 101.246 25.9035 101.946 29.1642C102.062 29.6882 102.237 30.154 102.412 30.6781C103.811 34.1717 106.259 37.3159 108.823 39.9362C111.213 42.3817 114.069 44.3032 116.925 46.05C121.121 48.612 125.609 50.1259 130.097 52.0473L133.012 51.5815Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 26,
    width: 33,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 26,
    width: 33,
    height: 27
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M133.008 51.5815C133.124 51.4651 131.784 49.6018 131.667 49.4854C130.093 47.2145 128.345 45.1183 126.538 43.0804C121.584 37.4324 115.755 31.9008 109.169 28.4655C108.295 27.9996 107.362 27.5338 106.371 27.1845C104.448 26.4275 101.242 25.9035 101.942 29.1642C102.058 29.6882 102.233 30.154 102.408 30.6781C103.807 34.1717 106.255 37.3159 108.819 39.9362C111.209 42.3817 114.065 44.3032 116.921 46.05C121.118 48.612 125.606 50.1259 130.093 52.0473L133.008 51.5815Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.93 45.0599C134.988 45.5839 134.522 44.07 134.289 43.6042C133.764 42.6143 133.123 41.6827 132.54 40.7511C130.792 38.1309 128.927 35.5107 126.945 33.0651C120.883 25.7285 113.015 19.9058 104.447 15.7135C102.057 14.549 97.5694 11.6376 94.9466 13.6173C91.3912 16.354 94.4803 26.6602 95.5878 30.0373C99.3763 41.3916 112.665 53.2699 125.896 53.5028L134.93 45.0599Z",
    fill: "white"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5231 9.60019C96.4648 9.1926 95.9986 10.2407 95.7654 10.6483C95.3574 11.347 95.1243 12.1622 94.8912 12.9191C94.3083 15.2482 93.9586 17.752 94.3666 20.081C95.6489 27.1847 99.9619 33.2403 104.858 38.4225C106.49 40.1111 108.18 41.7997 109.987 43.3718C112.027 45.1186 114.125 46.8072 116.515 48.0299C116.981 48.2628 118.322 49.1362 118.905 48.9616C119.721 48.7287 120.711 46.8654 121.294 46.2831C123.567 44.0123 126.423 42.3819 129.396 41.2174C129.979 40.9845 131.727 40.1111 132.427 40.4022C132.543 40.4604 130.27 42.7313 130.154 42.906C128.696 44.4781 127.298 46.1085 126.015 47.8553C123.859 50.7084 121.935 53.7362 120.478 56.9969C120.187 57.6374 119.487 60.5487 118.73 60.8399C117.972 61.131 115.815 59.4424 115.291 59.1513C111.677 56.9969 108.297 54.6096 105.149 51.9311C96.7563 44.5946 91.0443 34.3466 89.6455 23.3417C88.8878 17.6937 89.7038 11.1723 93.6672 6.74707L96.5231 9.60019Z",
    fill: "#EEC18F"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M159.24 175.663C137.441 175.954 89.4724 156.448 98.6231 107.596C111.562 38.0147 137.208 33.1819 159.531 32.5996H160.056C182.204 33.2401 207.558 38.5387 220.439 107.596C229.531 156.681 181.155 176.129 159.531 175.663H159.24Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 32,
    width: 125,
    height: 144
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M159.24 175.663C137.441 175.954 89.4724 156.448 98.6231 107.596C111.562 38.0147 137.208 33.1819 159.531 32.5996H160.056C182.204 33.2401 207.558 38.5387 220.439 107.596C229.531 156.681 181.155 176.129 159.531 175.663H159.24Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.426 60.5489C126.773 35.5113 143.967 33.0076 159.471 32.6582H159.996C175.383 33.124 192.344 35.8025 205.516 60.5489C192.111 38.3062 175.324 35.8025 159.996 35.3366H159.471C144.025 35.7442 127.006 38.0151 113.426 60.5489Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 32,
    width: 125,
    height: 144
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M159.24 175.663C137.441 175.954 89.4724 156.448 98.6231 107.596C111.562 38.0147 137.208 33.1819 159.531 32.5996H160.056C182.204 33.2401 207.558 38.5387 220.439 107.596C229.531 156.681 181.155 176.129 159.531 175.663H159.24Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.377 62.5283C108.064 72.4851 104.217 85.4697 101.128 102.356C100.72 104.452 100.487 106.49 100.312 108.469C99.5539 110.507 99.0877 112.778 99.0877 115.34C99.0877 153.246 126.132 169.84 159.471 169.84C192.81 169.84 219.854 153.246 219.854 115.34C219.854 112.836 219.446 110.566 218.63 108.528C218.455 106.548 218.164 104.452 217.814 102.356C214.725 85.4697 210.937 72.5433 206.565 62.5283C211.927 73.2421 216.649 87.7988 220.321 107.596C220.729 109.75 221.02 111.847 221.195 113.884C222.011 115.981 222.419 118.251 222.419 120.872C222.419 159.651 194.209 176.595 159.413 176.595C124.617 176.595 96.4648 159.651 96.4648 120.872C96.4648 118.31 96.9311 115.981 97.7471 113.884C97.922 111.847 98.2134 109.809 98.6214 107.654C102.293 87.7988 107.014 73.2421 112.377 62.5283Z",
    fill: "#CE8710"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M159.879 95.1348C179.812 95.1348 222.535 95.6006 222.535 120.871C222.535 159.65 194.325 176.594 159.529 176.594C124.733 176.594 96.4648 159.65 96.4648 120.871C96.4648 95.193 139.945 95.1348 159.879 95.1348Z",
    fill: "#F6DCBB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 95,
    width: 127,
    height: 82
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M159.879 95.1348C179.812 95.1348 222.535 95.6006 222.535 120.871C222.535 159.65 194.325 176.594 159.529 176.594C124.733 176.594 96.4648 159.65 96.4648 120.871C96.4648 95.193 139.945 95.1348 159.879 95.1348Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.377 62.5273C108.064 72.4841 104.217 85.4687 101.128 102.355C100.72 104.451 100.487 106.489 100.312 108.468C99.5539 110.506 99.0877 112.777 99.0877 115.339C99.0877 153.245 126.132 169.84 159.471 169.84C192.81 169.84 219.854 153.245 219.854 115.339C219.854 112.835 219.446 110.565 218.63 108.527C218.455 106.547 218.164 104.451 217.814 102.355C214.725 85.4687 210.937 72.5424 206.565 62.5273C211.927 73.2411 216.649 87.7978 220.321 107.595C220.729 109.749 221.02 111.846 221.195 113.883C222.011 115.98 222.419 118.25 222.419 120.871C222.419 159.65 194.209 176.594 159.413 176.594C124.617 176.594 96.4648 159.65 96.4648 120.871C96.4648 118.309 96.9311 115.98 97.7471 113.883C97.922 111.846 98.2134 109.808 98.6214 107.653C102.293 87.7978 107.014 73.2411 112.377 62.5273Z",
    fill: "#EEC18F"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.004 40.46C142.394 40.46 144.318 42.3814 144.318 44.7688C144.318 47.1561 142.394 49.0775 140.004 49.0775C137.615 49.0775 135.691 47.1561 135.691 44.7688C135.691 42.3814 137.615 40.46 140.004 40.46Z",
    fill: "#673620"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.969 49.0781C165.359 49.0781 167.282 50.9996 167.282 53.3869C167.282 55.7742 165.359 57.6957 162.969 57.6957C160.58 57.6957 158.656 55.7742 158.656 53.3869C158.656 50.9996 160.58 49.0781 162.969 49.0781Z",
    fill: "#673620"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.161 40.46C182.143 40.46 183.716 42.0321 183.716 44.0118C183.716 45.9915 182.143 47.5636 180.161 47.5636C178.179 47.5636 176.605 45.9915 176.605 44.0118C176.605 42.0321 178.179 40.46 180.161 40.46Z",
    fill: "#673620"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.943 37.1415C155.624 36.7922 158.13 38.7719 158.48 41.5668C158.829 44.3617 156.964 46.9236 154.283 47.273C151.602 47.6224 149.096 45.6427 148.746 42.8478C148.338 40.0529 150.261 37.4909 152.943 37.1415Z",
    fill: "#673620"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.31 56.7637C152.767 56.7637 153.933 57.9282 153.933 59.3839C153.933 60.8396 152.767 62.0041 151.31 62.0041C149.853 62.0041 148.688 60.8396 148.688 59.3839C148.688 57.9864 149.853 56.7637 151.31 56.7637Z",
    fill: "#673620"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.27 50.5333C150.086 50.6498 150.728 51.3485 150.611 52.2219C150.494 53.0371 149.795 53.6776 148.921 53.5611C148.105 53.4447 147.464 52.7459 147.58 51.8725C147.697 51.0573 148.454 50.4751 149.27 50.5333Z",
    fill: "#673620"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.547 45.002C171.363 45.002 172.062 45.7007 172.062 46.5159C172.062 47.331 171.363 48.0298 170.547 48.0298C169.731 48.0298 169.031 47.331 169.031 46.5159C169.031 45.6425 169.731 45.002 170.547 45.002Z",
    fill: "#673620"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.097 59.0928C168.913 59.0928 169.613 59.7915 169.613 60.6067C169.613 61.4218 168.913 62.1206 168.097 62.1206C167.281 62.1206 166.582 61.4218 166.582 60.6067C166.582 59.7915 167.281 59.0928 168.097 59.0928Z",
    fill: "#673620"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.525 36.9668C167.982 36.9668 169.148 38.1313 169.148 39.587C169.148 41.0427 167.982 42.2072 166.525 42.2072C165.068 42.2072 163.902 41.0427 163.902 39.587C163.902 38.1313 165.068 36.9668 166.525 36.9668Z",
    fill: "#673620"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.293 52.8047C141.517 52.8047 142.45 53.7945 142.45 54.9591C142.45 56.1818 141.459 57.1135 140.293 57.1135C139.069 57.1135 138.137 56.1236 138.137 54.9591C138.137 53.7363 139.128 52.8047 140.293 52.8047Z",
    fill: "#673620"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.528 62.7607C161.51 62.7607 163.083 64.3329 163.083 66.3126C163.083 68.2923 161.51 69.8644 159.528 69.8644C157.546 69.8644 155.973 68.2923 155.973 66.3126C155.973 64.3329 157.546 62.7607 159.528 62.7607Z",
    fill: "#673620"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.791 51.6396C177.19 51.6396 178.298 52.746 178.298 54.1434C178.298 55.5409 177.19 56.6472 175.791 56.6472C174.393 56.6472 173.285 55.5409 173.285 54.1434C173.285 52.746 174.451 51.6396 175.791 51.6396Z",
    fill: "#673620"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.274 107.014C123.336 107.014 128.232 109.226 128.232 111.905C128.232 114.583 123.336 116.796 117.274 116.796C111.212 116.796 106.316 114.583 106.316 111.905C106.375 109.168 111.271 107.014 117.274 107.014Z",
    fill: "#E96565"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.727 106.723C207.789 106.723 212.685 108.935 212.685 111.614C212.685 114.292 207.789 116.505 201.727 116.505C195.665 116.505 190.77 114.292 190.77 111.614C190.77 108.877 195.665 106.723 201.727 106.723Z",
    fill: "#E96565"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.899 105.5C146.473 104.859 148.804 106.49 150.145 109.11C151.486 111.73 151.311 114.408 149.795 115.049C148.222 115.689 145.89 114.059 144.55 111.439C143.209 108.819 143.384 106.14 144.899 105.5Z",
    fill: "#301007"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.1 105.5C172.526 104.859 170.195 106.49 168.854 109.11C167.514 111.73 167.689 114.408 169.204 115.049C170.778 115.689 173.109 114.059 174.45 111.439C175.79 108.819 175.674 106.14 174.1 105.5Z",
    fill: "#301007"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.99 61.1885C143.791 61.1885 150.902 68.4086 150.902 77.3173C150.902 86.226 143.791 93.4462 134.99 93.4462C126.189 93.4462 119.078 86.226 119.078 77.3173C119.078 68.4086 126.247 61.1885 134.99 61.1885Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.989 66.6621C141.401 66.6621 146.588 71.9025 146.588 78.3657C146.588 84.8289 141.401 90.0693 134.989 90.0693C128.578 90.0693 123.391 84.8289 123.391 78.3657C123.449 71.9608 128.636 66.6621 134.989 66.6621Z",
    fill: "#301007"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.382 70.1562C138.256 69.5157 140.004 70.4473 141.345 72.2523C142.685 74.0574 143.093 76.0371 142.219 76.6776C141.345 77.3181 139.596 76.3864 138.256 74.5814C136.915 72.7764 136.566 70.7967 137.382 70.1562Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.51 78.5986C143.501 78.5986 144.259 79.4138 144.259 80.3454C144.259 81.3353 143.501 82.0922 142.51 82.0922C141.519 82.0922 140.762 81.2771 140.762 80.3454C140.762 79.4138 141.578 78.5986 142.51 78.5986Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.009 61.1885C192.81 61.1885 199.921 68.4086 199.921 77.3173C199.921 86.226 192.81 93.4462 184.009 93.4462C175.208 93.4462 168.098 86.226 168.098 77.3173C168.098 68.4086 175.208 61.1885 184.009 61.1885Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.009 66.6621C190.42 66.6621 195.608 71.9025 195.608 78.3657C195.608 84.8289 190.42 90.0693 184.009 90.0693C177.598 90.0693 172.41 84.8289 172.41 78.3657C172.41 71.9608 177.598 66.6621 184.009 66.6621Z",
    fill: "#301007"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.397 70.1562C187.271 69.5157 189.02 70.4473 190.361 72.2523C191.701 74.0574 192.109 76.0371 191.235 76.6776C190.361 77.3181 188.612 76.3864 187.271 74.5814C185.931 72.7764 185.581 70.7967 186.397 70.1562Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.526 78.5986C192.517 78.5986 193.274 79.4138 193.274 80.3454C193.274 81.3353 192.517 82.0922 191.526 82.0922C190.535 82.0922 189.777 81.2771 189.777 80.3454C189.777 79.4138 190.593 78.5986 191.526 78.5986Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.524 146.084C149.739 144.803 151.837 144.162 153.935 143.754C154.81 143.58 155.626 143.522 156.5 143.463C157.724 143.347 159.006 143.463 160.347 143.58C162.736 143.813 165.359 144.279 168.215 145.21C171.712 146.375 175.617 147.947 179.989 150.043C180.28 150.218 180.688 150.101 180.863 149.81C181.038 149.519 180.921 149.111 180.63 148.937C176.55 146.025 172.936 143.638 169.497 142.008C166.408 140.552 163.494 139.562 160.755 139.329C158.54 139.155 156.442 139.446 154.46 140.086C153.294 140.494 152.128 141.018 151.079 141.717C149.622 142.648 148.34 143.813 146.999 145.268C146.766 145.443 146.766 145.734 146.941 145.967C146.999 146.2 147.291 146.2 147.524 146.084Z",
    fill: "#301007"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M113.718 207.339C113.718 207.339 124.851 199.245 144.318 177.993C148.048 173.858 147.815 167.512 143.677 163.727C139.597 159.942 133.185 160.233 129.397 164.367C111.736 183.641 101.77 191.094 101.77 191.094C97.2818 194.413 96.2909 200.701 99.6132 205.185C102.877 209.668 109.23 210.658 113.718 207.339Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 161,
    width: 50,
    height: 49
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M113.718 207.339C113.718 207.339 124.851 199.245 144.318 177.993C148.048 173.858 147.815 167.512 143.677 163.727C139.597 159.942 133.185 160.233 129.397 164.367C111.736 183.641 101.77 191.094 101.77 191.094C97.2818 194.413 96.2909 200.701 99.6132 205.185C102.877 209.668 109.23 210.658 113.718 207.339Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.564 167.279C149.214 167.396 148.806 168.211 148.573 168.502C147.699 169.492 146.825 170.54 145.892 171.472C143.095 174.383 139.656 176.887 137.149 180.031C136.392 180.963 135.051 182.302 134.235 183.117C131.904 185.563 129.572 187.95 127.183 190.337C125.9 191.56 124.676 192.783 123.394 194.005C119.722 197.557 115.875 201.226 111.329 203.671C107.949 205.476 104.393 206.291 100.838 204.661C99.6139 204.079 98.4482 203.438 97.3991 202.565C95.8254 201.284 94.4849 199.712 93.3192 198.023C93.494 197.848 92.9112 198.314 92.7363 198.489C92.4449 198.838 92.5614 199.304 92.6197 199.712C92.9112 201.051 93.6106 202.215 94.31 203.38C96.2334 206.699 98.5065 209.901 101.071 212.754C102.237 214.035 103.636 215.433 105.559 215.084C107.774 214.676 109.814 213.22 111.679 211.998C115.118 209.843 118.44 207.514 121.704 205.069C133.711 196.16 146.067 186.319 155.509 174.616L149.564 167.279Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 161,
    width: 50,
    height: 49
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M113.718 207.339C113.718 207.339 124.851 199.245 144.318 177.993C148.048 173.858 147.815 167.512 143.677 163.727C139.597 159.942 133.185 160.233 129.397 164.367C111.736 183.641 101.77 191.094 101.77 191.094C97.2818 194.413 96.2909 200.701 99.6132 205.185C102.877 209.668 109.23 210.658 113.718 207.339Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.995 201.342C104.336 203.147 106.784 203.555 108.474 202.332C110.164 201.109 110.456 198.605 109.115 196.858C107.775 195.053 105.327 194.646 103.636 195.869C101.946 197.15 101.655 199.595 102.995 201.342Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 161,
    width: 50,
    height: 49
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M113.718 207.339C113.718 207.339 124.851 199.245 144.318 177.993C148.048 173.858 147.815 167.512 143.677 163.727C139.597 159.942 133.185 160.233 129.397 164.367C111.736 183.641 101.77 191.094 101.77 191.094C97.2818 194.413 96.2909 200.701 99.6132 205.185C102.877 209.668 109.23 210.658 113.718 207.339Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.112 182.069C123.103 183.408 124.968 183.699 126.25 182.709C127.591 181.719 127.824 179.856 126.891 178.575C125.959 177.294 124.035 176.945 122.753 177.935C121.412 178.866 121.121 180.729 122.112 182.069Z",
    fill: "#673620"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M141.054 181.369C156.617 174.847 158.598 154.06 144.901 153.245C140.122 152.954 133.885 158.602 131.612 163.027C131.904 161.164 131.612 156.506 128.698 157.729C127.532 158.194 125.784 162.678 126.075 168.093C129.048 174.09 135.867 180.728 141.054 181.369Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 153,
    width: 29,
    height: 29
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M141.054 181.369C156.617 174.847 158.598 154.06 144.901 153.245C140.122 152.954 133.885 158.602 131.612 163.027C131.904 161.164 131.612 156.506 128.698 157.729C127.532 158.194 125.784 162.678 126.075 168.093C129.048 174.09 135.867 180.728 141.054 181.369Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.484 182.65C137.559 183.232 162.271 165.473 153.121 152.372C169.149 148.296 162.33 163.028 162.33 163.028L142.454 187.774L126.484 182.65Z",
    fill: "#301007"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_197_181600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 153,
    width: 29,
    height: 29
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M141.054 181.369C156.617 174.847 158.598 154.06 144.901 153.245C140.122 152.954 133.885 158.602 131.612 163.027C131.904 161.164 131.612 156.506 128.698 157.729C127.532 158.194 125.784 162.678 126.075 168.093C129.048 174.09 135.867 180.728 141.054 181.369Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_197_181600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.253 153.012C141.286 148.412 132.135 159.766 132.135 159.766C132.135 159.766 132.077 161.455 131.902 162.154C131.611 163.318 131.378 164.541 131.145 165.705C131.319 165.24 131.727 164.832 132.019 164.483C132.66 163.609 133.301 162.736 134 161.863C136.157 159.184 138.955 156.389 142.277 155.225C145.832 154.002 150.379 154.701 152.885 157.728C153.934 159.009 154.459 160.465 154.808 162.037C154.808 162.037 154.925 161.63 154.983 161.63C155.1 161.338 155.216 161.106 155.275 160.814C155.508 159.999 155.566 159.184 155.449 158.311C155.041 155.923 153.351 154.002 151.253 153.012Z",
    fill: "#98502F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_181600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191,
    height: 310,
    fill: "white",
    transform: "translate(64 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiraffeAfraid);
export default __webpack_public_path__ + "static/media/giraffe_afraid.d7f47ee94dc4b6a749f48fd6b23f2341.svg";
export { ForwardRef as ReactComponent };